(function (appComponents) {

	appComponents.controllers.registration = function (Components) {
		var registration = {};

		registration.name = "registration";


		Components.getControllerPrototype().extend(registration);

		registration._helpers = registration._getService("helpers");
		registration._modals = registration._getService("modals");


		registration.elements = {
			get salesManagers() {
				return $('[pc-container="registration--sales-manager-table-body"]');
			},
			get salesManagerName() {
				return $('[pc-container="registration--sales-manager-name"]');
			},
			get salesManagerHiddenUid() {
				return $('[pc-container="registration--sales-manager-hidden-uid"]');
			},
			get salesManagerTableForm() {
				return $('[pc-container="registration--sales-manager-table-form"]');
			},
			get salesManagersModal() {
				return $('.price-req-manager-modal');
			},
			get overview() {
				return $('[pc-container="registration--overview"]');
			}

		};

		registration.bindings = function () {
			$(document).off("click", "[pc-container='registration--sales-manager-select-btn']").on("click", "[pc-container='registration--sales-manager-select-btn']", function () {
				var uid = $('input[name=manager]:checked').val();
				registration.handlers.onSalesManagerSelect(uid);
				return false;
			});
			$(document).off("submit", "[pc-container='registration--sales-manager-search-form']").on("submit", "[pc-container='registration--sales-manager-search-form']", function () {
				registration.handlers.onSalesManagerFormSubmit(this);
				return false;
			});
			$(document).off("submit", "[pc-container='registration--form']").on("submit", "[pc-container='registration--form']", function () {
				registration.handlers.onRegistrationSubmit(this);
				return false;
			});
			$(document).off("click", "[pc-container='registration--sales-manager-not-spec-btn']").on("click", "[pc-container='registration--sales-manager-not-spec-btn']", function () {
				registration.handlers.onDontKnowMyManager(this);
			});
		};

		registration.populateRoles = function () {
			return registration._api.registration.getRoles().then(function (res) {
				if (res && res.status == 200) {
					registration.context.roles = res.body;
				}
			});
		};
		
		registration.populateBuyerTypes = function () {
			return registration._api.registration.getBuyerTypes().then(function (res) {
				if (res && res.status == 200) {
					registration.context.buyerTypes = res.body;
				}
			});
		};

		registration.populateInitialContext = function () {
			var defToReturn = $.Deferred();

			var defRoles = registration.populateRoles();

			registration.context.registerForm = registration._stash.registerForm;
			
			registration.context.buyerTypes = registration._stash.buyerTypes;
			
			$.when(defRoles).then(function () {
				defToReturn.resolve();
			});

			return defToReturn;
		};

		registration.renderSalesManagers = function () {
			var html = registration.templates.salesManagers(registration.context);
			registration.elements.salesManagers.html(html);

			registration._applyScript.icheck();
			registration._applyScript.select2();
		};

		registration.renderSuccessView = function () {
			var html = registration.templates.successView(registration.context);
			registration.elements.overview.html(html);
		};

		registration.handlers = {
			onDontKnowMyManager: function () {
				registration.elements.salesManagerName.val("Not specified");
			},
			onRegistrationSubmit: function (form) {
				var hasErrors = registration._helpers.checkFormForErrors(form);
				if (hasErrors) {
					registration._modals.error.show(registration._messages.formError);
					return;
				}
				var validPassword = registration._helpers.checkPassword(form);
				if (validPassword) {
					registration._modals.error.show(registration._messages.formError);
					return;
				}
				var formData = registration._utils.getFormData(form);
				formData.termsAndConditionsChecked = true;

				registration._api.registration.registerCustomer(formData).then(function (res) {
					if (res && res.status == 200) {
						registration.renderSuccessView();
					} else {
						console.log(res);
						registration._modals.error.show(registration._messages.registrationError + " " + res.message);
					}
				});
			},
			onSalesManagerFormSubmit: function (form) {
				var formData = registration._utils.getFormData(form);
				registration._api.registration.getSalesManagers(formData).then(function (res) {
					if (res && res.status == 200) {
						registration.context.salesManagers = res.body;
						registration.renderSalesManagers();
					} else if (res.status == 210) {
						registration._modals.warning.show(registration._messages.noResults);
					} else {
						registration._modals.warning.show(res.message);
					}
				});
			},
			onSalesManagerSelect: function (uid) {
				var manager = null;
				if (!registration.context.salesManagers) return;
				registration.context.salesManagers.forEach(function (el) {
					if (!manager) {
						if (el.uid == uid) {
							manager = el;
						}
					}
				});
				if (manager) {
					registration.elements.salesManagerName.val(manager.firstName + " " + manager.lastName);
					registration.elements.salesManagerHiddenUid.val(manager.uid);
					registration.elements.salesManagersModal.modal("hide");
				}
			}
		};

		registration.init = function () {

			registration.populateInitialContext().then(function () {

				registration._renderPageTemplate();

				registration._helpers.populateCountries();

				registration._bindings();

				registration._events.dispatchEvent("controllerInitialized");

			}).fail(function (e) {
				console.log(e);
			});

		};


		return registration;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});